
import { useTranslation } from "react-i18next";

const Terms = () => {
	const { t } = useTranslation();
	const renderHeader = () => {
		return (
			<header className="container rounded-xl ">
				<div className="mx-auto max-w-screen-md space-y-5">
					<h1 className=" max-w-4xl text-3xl font-semibold text-neutral-900  md:text-4xl md:!leading-[120%] lg:text-4xl ">
						شروط وأحكام الخدمة
					</h1>
					<span className="block pb-1 text-base text-neutral-500  md:text-lg ">
						{
							<>
								عزيزي المسافر,,, برجاء الاطلاع علي كافة الشروط والارشادات التي
								بموجبها تقوم الشركة بتوفير خدمة النقل بكافة وسائلها لكم . وتنطبق
								هذه الشروط علي كل التذاكر الصادرة من الشركة وتحدد الأسس
								القانونية من قبل الشركة تجاه المسافر ويعتبر أي شخص يسافر من خلال
								شركائنا قد وافق عل تلك الشروط والأحكام والتي بيانها كالتالي
							</>
						}
					</span>
				</div>
			</header>
		);
	};

	const renderContent = () => {
		return (
			<div
				id="single-entry-content"
				className="dark:prose-dark prose-sm prose mx-auto !max-w-screen-md dark:prose-invert sm:prose lg:prose-lg"
			>
				<div>
					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						الأحكام العامة :
					</span>

					<li>
						علي المسافر التواجد في المحطة للمغادرة قبل الموعد المقرر بوقت كافي
						لا يقل عن 30 دقيقة ,, وذلك لتوفر مساحة من الوقت لإجراءات الصعود ومنع
						أي تأخير .
					</li>

					<li>
						تتوقف الرحلات فقط في المحطات الرسمية وفقا لخط السير المحدد والمعلن
						للرحلة من قبل الشركة التي تم الحجز من خلالها .
					</li>

					<li>
						الوصول الي محطة المغادرة قبل موعد الرحلة هو مسئوليه خالصة علي
						المسافر ,,, وفي حالة عدم لحاق المسافر بموعد الرحلة تعتبر التذكرة
						لاغية ولا يحق له طلب استرداد قيمة أي مرتجع او تعويض .
					</li>

					<li>
						لا يسمح بتأخير او العودة مرة اخري لوسيلة النقل لنقطة التجمع لالتقاط
						المتخلفين عن الرحلة بعد التحرك للرحلة في الموعد المحدد والمعلن من
						جانب الشركات .
					</li>

					<li>
						الشركة غير مسئولة عن أي مصاريف إضافية يتحملها المسافر في حالة تخلفه
						عن موعد محدد بسبب التأخير في موعد المغادرة أو الوصول ,,, ولا يحق
						المطالبة بتقديم أي تعويض أو مرتجع في حالة وجود التأخير عن الرحلة .
					</li>

					<li>
						ستبذل الشركة قصاري جهدها لتوفير كافة الخدمات والوسائل المعلن عنها
						علي متن الرحلات المجهزة بذلك طبقا لفئة الخدمة المحددة بتذكرة المسافر
						.
					</li>

					<li>
						علي المسافر الالتزام بتعليمات الرحلة كاملة ,,, والمسافر مسئول عن أي
						تلف قد يسببه للمقاعد او أي تجهيزات داخل وسيلة النقل هذه ويتحمل
						المسافر قيمة التآلفيات والاضرار وكذلك المسائلة القانونية في حالة
						رفضة التعويض المحدد من قبل الشركات .
					</li>

					<li>
						في حالة رغبة المسافر بأبداء أي ملاحظات او الاخطار بوجود مشكلة أو
						شكوي بخصوص الخدمة يمكن للمسافر ان يتقدم بإخطار الشركة من خلال
						القنوات الرسمية مثل (فرع الشركة او الأرقام المحددة او الموقع الرسمي
						علي الانترنت) ,,, وفي خلال 5 أيام من تاريخ الأخطار سيتم التحقيق
						بخصوص الشكوى المقدمة والرجوع للمسافر خلال مدة أقصاها 14 يوم .
					</li>

					<li>
						قد يتم الغاء رحلة او تعديل موعدها وقد يكون ذلك نتيجة لعوامل خارجة عن
						أرادة الشركة مثل (الطقس وحوادث الطرق والتعليمات الأمنية والمشكلات
						الفنية الطارئة او أي ظروف قهرية أخري) ,,, وفي هذه الحالة لا يحق
						للمسافر المطالبة بأي تعويضات نتيجة أي اضرار يحتمل وقوعها نتيجة لذلك
						.
					</li>

					<li>يمنع التدخين نهائياً اثناء الرحلة.</li>
					<li>{t('fawry_terms')}</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						تعليمات الحجز :
					</span>
					<li>
						التذكرة صالحة للسفر في الموعد المحدد لها وعلي الخدمة المحددة بها ومن
						خلال الشركة التي تم الحجز بها والخاضعة للقيود او البيانات المدونة
						عليها عند الإصدار كنوع الخدمة وتاريخ السفر واليوم والساعة المحددة
						والسعر وكافة البيانات الأخرى .
					</li>

					<li>
						علي المسافر التأكد من جميع البيانات الواردة علي التذكرة فور إصدارها
						واخطار الشركة في حالة وجود أي خطأ بتذكرة الحجز .
					</li>

					<li>
						علي المسافر تقديم تذكرة صالحة للسفر ولا يوجد بها أي تلف او أخطاء
						بالبيانات وفي حالة ثبوت ذلك عند السفر تصبح التذكرة لاغية ويحق للشركة
						رفض إعادة اصدار تذكرة بديل عنها .
					</li>

					<li>
						يجب أن تحتفظ بتذكرتك أثناء الرحلة ويجب ان تقدمها في حال طلبها للفحص
						. اذا لم تكن تذكرتك معك علي متن الرحلة واتضح عدم قيامك بالحجز مسبقا
						يتحتم عليك دفع ثمن تذكرة أخري طبقا لتوافر المقاعد وحين أذن يتم شراء
						التذكرة من خلال السائق فقط .
					</li>

					<li>
						الشركة لن تقوم باستبدال أي تذاكر مفقودة او مسروقه وفي حالة عدم
						التمكن من اصدار بدل فاقد للتذكرة علي المسافر شراء تذكرة اخري وفقا
						لقيمة التذكرة المعلنة للتمكن من السفر .
					</li>

					<li>
						في حالة زيادة أو انخفاض أسعار التذاكر المعلنة بعد شراء التذكرة لا
						يحق مطالبة الشركة بدفع او استرداد فارق السعر ,,, ويمكن استرجاع او
						تعديل التذاكر المخفضة الخاصة بالعروض ولكن مع خسارة الخصم الممنوح في
						حالة الإلغاء عامة او التعديل بعد انتهاء مدة الخصم الممنوح .
					</li>

					<li>
						يحق للشركة تعديل جدول الرحلات اليومي او تعديل أسعار التذاكر دون
						اخطار مسبق .
					</li>

					<li>
						في حالة الغاء او تعديل موعد الرحلة من خلال الشركة ونتيجة لذلك لن
						يتمكن المسافر من السفر من خلال شركتنا ,,, يحق للمسافر المطالبة
						باسترداد قيمة المبلغ المدفوع للتذكرة مرة أخري .
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						الحجز الإلكتروني :
					</span>

					<li>
						في حالة الحجز الالكتروني يرجي التأكد من جميع البيانات الظاهرة علي
						شاشة الحجز الخاصة بالموقع الالكتروني او تطبيق الهاتف (سواء بيانات
						الرحلة كاملة او بيانات المسافر) وفي حالة حدوث أي خطأ في بيانات
						الرحلة او المسافر تكون مسئولية العميل .
					</li>

					<li>
						لا يمكن حجز اكثر من 4 مقاعد على الرحلة الواحدة و يمكن حجز 4 مقاعد
						للذهاب و مثلها للعودة بأجمالي 8 مقعد في نفس الوقت و لحجز المزيد من
						المقاعد يمكنك الحجز مرة أخرى ,, وفي حالة الاحتياج لعدد تذاكر أكثر
						يجب سداد قيمة التذاكر المحجوزة أولا ثم تسجيل حجز عدد تذاكر أخر (طبقا
						لسياسة الشركة التي يتم الحجز من خلالها) .
					</li>

					<li>
						يمكن الحجز فقط قبل ميعاد الرحلة المطلوبة بأكثر من 4 ساعات (طبقا
						لسياسة الشركة التي يتم الحجز من خلالها) .
					</li>

					<li>
						يمكن الغاء حجز التذاكر المحجوزة قبل موعد الرحلة بأكثر من 8 ساعات من
						خلال زيارة اقرب فرع للشركة او من خلال الموقع الإلكتروني او الاتصال
						بالخط الساخن للشركة مقابل رسوم إلغاء تحدد (طبقا لسياسة الإلغاء
						والاسترجاع للشركة التي يتم الحجز من خلالها) .
					</li>

					<li>
						يجب علي الراكب ان يقدم التذكرة سواء مطبوعة او علي الهاتف الذكي الخاص
						به ليتمكن من ركوب الرحلة .
					</li>

					<li>
						المسافرين أصحاب التذاكر الذين قاموا بحجز رحلة ذهاب وعودة وغير محدد
						تاريخ العودة في التذكرة يجب ان يسجلوا حجز مسبق لرحلة العودة وذلك
						لضمان توافر مقاعد .
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						طباعه التذاكر الإلكترونية :
					</span>

					<li>
						يقوم العميل بطباعه التذاكر الخاصة به بعد الدفع من خلال موقعنا على
						ورق عادى ويمكنه الركوب بهذا السند مباشره .
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						تعديل موعد أو الغاء الرحلة :
					</span>
					<div></div>
					<span className=" max-w-4xl text-lg font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
					(سياسة الاستبدال والاسترجاع)					</span>

					<li>
						يسمح بإلغاء الحجز أو بأجراء تعديل علي موعد السفر المدون بالتذكرة
						مقابل نسبة خصم من ثمن التذكرة (طبقا لسياسة الشركة التي يتم الحجز من
						خلالها) كمصروفات إدارية علي ان يكون ذلك قبل موعد الرحلة بوقت كافي
						وطبقا للإمكانية المتوفرة علي متن الرحلات .
					</li>

					<li>
						في حالة تعديل موعد السفر المدون علي التذكرة خلال 4 ساعات قبل موعد
						الرحلة سيطبق نسبة خصم أكبر علي قيمة التذكرة (طبقا لسياسة الشركة التي
						يتم الحجز من خلالها) كمصروفات إدارية علي كل تذكرة .
					</li>

					<li>
						في حالة طلب الغاء التذكرة خلال ال 4 ساعات قبل موعد الرحلة سيطبق نسبة
						خصم علي قيمة التذكرة المستردة كمصروفات إدارية علي كل تذكرة (طبقا
						لسياسة الشركة التي يتم الحجز من خلالها) .
					</li>

					<li>لا يمكن التعديل او الإلغاء في اخر ساعتين قبل اقلاع الرحلة .</li>

					<li>
						التذاكر المباعة بتخفيض او عروض يمكن استرجاعها بخسارة الخصم الممنوح
						بالإضافة للمصروفات الإدارية المحتمة للإلغاء .
					</li>

					<li>
						في حالة عدم الحضور للسفر بالرحلة المحددة بالتذكرة تصبح التذكرة لاغية
						ولا يحق للمسافر طلب رد قيمة التذكرة او استخدامها علي رحلة اخري .
					</li>

					<li>
						لا يحق طلب استرجاع قيمة تذكرة مفقودة او مسروقة اذا تبين قيام المسافر
						بالحجز .
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						تعليمات السفر :
					</span>

					<li>
						تأكد من وجودك في الرحلة الصحيحة التي تم حجزها من خلال الشركة .
					</li>

					<li>
						في حالة التوقف للاستراحات يجب الرجوع الي وسيلة النقل في الوقت المحدد
						للاستراحة بالضبط ,,, والشركة غير مطالبة بتعطيل موعد الرحلة لانتظار
						مسافر ولا يحق المطالبة بدفع أي تعويض او مصاريف إضافية قد تحدث نتيجة
						تخلف المسافر عن موعد اقلاع الرحلة من موقع الاستراحة .
					</li>

					<li>
						المسافر مطالب قانونا بارتداء حزام الأمان المتوفر في أي من الرحلات
						طول الوقت اثناء الرحلة .
					</li>

					<li>
						يمنع التدخين نهائياً اثناء الرحلة بأي شكل من اشكال التدخين (سجائر او
						سجائر الكترونية او شيشة او ما شبة).
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						سفر الأطفال :
					</span>

					<li>
						تختلف قيمة حجز التذاكر علي حسب عمر الطفل من شركة الي اخري (طبقا
						لسياسة الشركة التي يتم الحجز من خلالها) .
					</li>

					<li>
						لا يتم تخصيص مقعد للأطفال عن عمر محدد (طبقا لسياسة الشركة التي يتم
						الحجز من خلالها) ,,, ولا يتم دفع أي رسوم علي انتقالهم بشرط ان يكونوا
						بمصاحبة ذويهم بحد أقصي طفل لكل تذكرة .
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						الحقائب والشحن :
					</span>

					<li>
						الحقائب يتم تحميلها بالرحلات علي مسئولية أصحابها وينطبق عليها
						الاحجام القياسية للنقل (طبقا لسياسة الشركة التي يتم الحجز من
						خلالها).
					</li>

					<li>
						يسمح لكل راكب بعدد محدد من الحقائب ووزن محدد يختلف باختلاف نوع
						الرحلة والشركة التي تم الحجز عليها (طبقا لسياسة الشركة التي يتم
						الحجز من خلالها).
					</li>

					<li>
						قد تنطبق رسوم شحن علي اية حقيبة إضافية مع المسافر وسيتم تطبيق رسوم
						إضافية طبقا لرسوم شحن المقررة من الشركات وعلي المسافر سداد القيمة
						المستحقة قبل موعد السفر (طبقا لسياسة الشركة التي يتم الحجز من
						خلالها).
					</li>

					<li>
						يلتزم المسافر علي مسئوليته الشخصية من التأكد من استلام ملصق كل حقيبة
						أو شحنة تابعة له والمصدر من المكاتب الخاصة التابعة للشركة المسافر من
						خلالها .
					</li>

					<li>
						في حالة اخطار الشركة بنسيان او فقد احد الحقائب علي متن الرحلة او
						بداخل المحطة سيتم اتخاذ اللازم تجاهها متي وجددت واذا لم تتقدم في مدة
						أقصاها شهر من عثورنا علي الحقيبة سيتم التصرف بالشكل الذي تراه الشركة
						وسيتم فتح وفحص أي حقيبة متروكة او مفقودة وفي حال وجود أي شيء يعد
						خطير او قابل للفساد او غير صالح للتخزين سيتم التخلص منها .
					</li>

					<li>
						اذا وجد أي حقيبة او متعلقات تخص راكب اخر بالرحلة او بالمحطة علي
						المسافر تسليمها فورا لاحد محطاتنا الرسمية ,,, وفي حال وجددت أي
						متعلقات علي متن الرحلة يرجي تسليمها فورا للمختص .
					</li>

					<li>
						الشركات لا تتحمل مسئوليه فقدان او تلف امتعة الركاب او أي من ممتلكات
						الركاب أي كان سببها الا اذا ثبت ان هذه الخسارة او الاضرار التي لحقت
						بالحقيبة كانت ناتجة عن الإهمال او الاخلال بالخدمة المقدمة من الشركة
						.
					</li>

					<li>
						الادوية والنقود والمستندات الخاصة والرسمية او أي أشياء اخري ثمينة لا
						يجب تحميلها بغرفة الشحن ويجب ان تكون ملازمة للمسافر طيلة الوقت دون
						ادني مسئولية علي الشركات .
					</li>

					<li>
						في حال ثبوت ان الشركة قد تسببت في خسارة او تلف أي حقيبة سيتم تعويض
						العميل بمبلغ مالي محدد (طبقا لسياسة الشركة التي يتم الحجز من خلالها)
						.
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						الامتعة والمواد المحظور نقلها :
					</span>

					<li>
						لا يسمح باصطحاب الخمور علي متن الرحلة وكذلك اصطحاب او شحن الحيوانات
						والطيور والاسماك الحية .
					</li>

					<li>
						يسمح بشحن أي مأكولات او مجمدات داخل ايس بوكس محكم الغلق (طبقا لسياسة
						الشركة التي يتم الحجز من خلالها) .
					</li>

					<li>
						يحق للشركة التي يتم الحجز من خلالها رفض نقل أي من الأشياء التالية
						بالحقائب ويلتزم المسافر بعد اصطحابها علي متن الرحلة :
					</li>

					<li>
						الغازات المضغوطة :(المبردة بشدة / القابلة للاشتعال / غير القابلة
						للاشتعال والسامة / واسطوانات التنفس تحت الماء ).
					</li>

					<li>يحذر تماما حمل أي مواد حادة داخل الرحلة .</li>

					<li>
						المواد المسببة للتأكل مثل : ( الاحماض / القلويات / بطاريات الخلايا
						السائلة ).
					</li>

					<li>
						العوامل المسببة للأمراض مثل : ( البكتريا / الجراثيم / ......الخ ).
					</li>

					<li>
						المتفجرات والأسلحة والذخائر ( الألعاب النارية / الشعلات المضيئة /
						كبسولات المسدس / بندقية الرماية / مسدس الألعاب النارية / الخراطيش
						الفارغة ).
					</li>

					<li>
						المواد السائلة والصلبة القابلة للاشتعال مثل :(وقود الولاعات او
						السخانات / علب الكبريت / الدهانات / سوائل تمديد الدهان / المواد سهلة
						الاشتعال ).
					</li>

					<li>
						المواد المشعة / المواد المؤكسدة مثل :( مسحوق التبيض / البيروكسيد ).
					</li>

					<li>
						المواد السامة مثل :( الزرنيخ السيانيد / مبيدات الحشرات ورش المزارع
						).
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						الزئبق والمواد الممغنطة .
					</span>

					<li>
						أي أجهزة او معدات بها زئبق ,,, ويمكن لبعض الشركات حمل المواد او
						معدات الطبية في كميات محدودة .
					</li>

					<li>الدرجات او الوسائل المماثلة .</li>

					<li>
						تتضمن هذه القوانين امن وسلامة الركاب والرحلة وعدم الالتزام بهذه
						الضوابط ممكن ان يضع المسافر تحت طائلة القانون .
					</li>

					<span className=" max-w-4xl text-xl font-semibold text-neutral-900 dark:text-neutral-100 md:text-3xl md:!leading-[120%] lg:text-2xl ">
						حدود مسئولية الشركة :
					</span>

					<li>
						ستبذل شركةئنا جهدا وافرا لتوفير خدمة مميزة تليق بعملائنا تتميز
						بالراحة والأمان وملائمة لكافة الركاب في كافة المجالات ونعمل علي
						تقليل العوائق التي تواجه المسافر للاستمتاع خلال الرحلة .
					</li>

					<li>
						يحكم القانون المصري مسئولية الشركات الناقلة وحدودها فيما يتعلق
						بالتعويضات المستحقة تجاه المسافر واي نزاع او خلاف قد ينشأ بين الشركة
						الناقلة والمسافر يتم تفسيره والقضاء فيه بموجب احكام هذا القانون
						وينعقد الاختصاص لمحاكم جمهورية مصر العربية دون غيرها من محاكم البلاد
						والاقطار الأخرى .
					</li>
				</div>
			</div>
		);
	};

	return (
		<div className="nc-PageSingle pt-8 lg:pt-16 my-12  mx-2">
			{/* <Helmet>
				<title>Terms and Conditions|| Telefreik For Booking</title>
			</Helmet> */}
			{renderHeader()}
			

			<div className="nc-SingleContent container space-y-10">
				{renderContent()}
			</div>
		</div>
	);
};

export default Terms;
